import apiurl from './apiurl';
const axios = require('axios');

const consultaEstado = async (params,idToken) =>{
    console.log(params);
    
    return new Promise(async (resolve,reject) => {
        try {
            const response = await axios({
                'method':'GET',
                'url':apiurl +'consultadocumentosresumen',
                'headers': {
                    'content-type':'application/json',
                    'Authorization':"Bearer "+idToken
                },
                'crossdomain': true,
                'params': {
                    ...params
                }
            })
            resolve(response.data)
        } catch (error) {
            reject(error);
        }

    })
    
}
export default consultaEstado;